import { render, staticRenderFns } from "./ProductControl.vue?vue&type=template&id=654a8ba7&scoped=true&"
import script from "./ProductControl.vue?vue&type=script&lang=js&"
export * from "./ProductControl.vue?vue&type=script&lang=js&"
import style0 from "./ProductControl.vue?vue&type=style&index=0&id=654a8ba7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654a8ba7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VDialog,VPagination,VSelect,VTextField})
